






















import Vue from 'vue'
export default Vue.extend({
  props: {
    file: {
      type: Object,
      default: () => ({})
    },
    selectedRowKeys: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {}
  },
  computed: {
    check() {
      return this.selectedRowKeys &&
        this.selectedRowKeys.length &&
        this.selectedRowKeys.indexOf(this.file.id) != -1
        ? true
        : false
    },
    icon() {
      let icon = 'file-unknown'
      if (this.file.isfolder === true) {
        icon = 'folder'
      } else {
        if (this.file.contentType && this.file.contentType.indexOf('image/') !== -1) {
          icon = 'file-image'
        } else {
          icon = 'file-text'
        }
      }
      return icon
    },
    color() {
      let color = '#52c41a'
      if (this.file.isfolder === true) {
        color = '#ffe17b'
      } else {
        if (this.file.contentType && this.file.contentType.indexOf('image/') !== -1) {
          color = '#71ce52'
        } else {
          color = '#92a8c1'
        }
      }
      return color
    }
  },
  methods: {
    onChange() {
      this.$emit('check', this.file)
    },
    clickFile() {
      this.$emit('clickFile', this.file)
    },
    dblclickFile() {
      if (this.file.isfolder) {
        this.$emit('dblclickFlor', this.file)
      } else {
        this.$emit('dblclickFile', this.file)
      }
    }
  }
})
